(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4040],{

/***/ 48976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconCalendar = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 26 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M.5 2.174h25V23.5H.5V2.174ZM1.13 7.256H26M5.652 0v4.465M20.35 0v4.465M5.652 12.837h2.261M11.87 12.837h2.26M18.088 12.837h2.26M5.652 17.86h2.261M11.87 17.86h2.26M18.088 17.86h2.26",
  stroke: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconCalendar);

/***/ }),

/***/ 16971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _form_CustomField__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56375);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49727);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41197);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34495);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66261);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40670);










var DropdownField = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, children = _param.children, isActive = _param.isActive, shadowRef = _param.shadowRef, onClear = _param.onClear, onApply = _param.onApply, _angle = _param.angle, angle = _angle === void 0 ? true : _angle, _footer = _param.footer, footer = _footer === void 0 ? true : _footer, disableClear = _param.disableClear, disableApply = _param.disableApply, _scrollTop = _param.scrollTop, scrollTop = _scrollTop === void 0 ? false : _scrollTop, clearTranslation = _param.clearTranslation, applyTranslation = _param.applyTranslation, triggerClose = _param.triggerClose, _defaultOpen = _param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "variant",
        "children",
        "isActive",
        "shadowRef",
        "onClear",
        "onApply",
        "angle",
        "footer",
        "disableClear",
        "disableApply",
        "scrollTop",
        "clearTranslation",
        "applyTranslation",
        "triggerClose",
        "defaultOpen"
    ]);
    var isLaptop = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__/* .useResponsive */ .F)().isLaptop;
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var contentRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultOpen), show = ref[0], setShow = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultOpen), contentVisible = ref1[0], setContentVisible = ref1[1];
    var isSimple = variant.length !== 0 && variant.includes("content-simple");
    var scroll = react_scroll__WEBPACK_IMPORTED_MODULE_4__["default"].animateScroll;
    // Handle click outside to close dropdown
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(event) {
            if (!defaultOpen) {
                if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                    setShow(false);
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // Handle triggerClose prop changes
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        triggerClose && setShow(false);
    }, [
        triggerClose
    ]);
    // Handle shadow effect when dropdown is visible
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (shadowRef && !defaultOpen) {
            if (show) {
                var ref;
                (ref = shadowRef.current) === null || ref === void 0 ? void 0 : ref.classList.add("isVisible");
            } else {
                var ref1;
                (ref1 = shadowRef.current) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("isVisible");
            }
        }
    }, [
        shadowRef,
        show
    ]);
    // Handle content visibility for render optimization
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (show) {
            // Make content visible immediately when showing
            setContentVisible(true);
        } else {
            // Add delay to hide content after transition completes
            var timer = setTimeout(function() {
                setContentVisible(false);
            }, 300) // Adjust timing to match your CSS transition duration
            ;
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        show
    ]);
    // Handle clear action
    var handleClear = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        onClear && onClear();
        setShow(false);
        if (scrollTop) {
            scroll.scrollToTop();
        }
    }, [
        onClear,
        scrollTop,
        scroll
    ]);
    // Handle apply action
    var handleApply = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        onApply && onApply();
        setShow(false);
        if (scrollTop) {
            scroll.scrollToTop();
        }
    }, [
        onApply,
        scrollTop,
        scroll
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: wrapperRef,
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("field", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default())),
        role: "group",
        "aria-labelledby": "formik-group",
        children: [
            isSimple ? !isLaptop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().field__label),
                children: props.value
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_CustomField__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                variant: variant,
                type: "text",
                readOnly: true,
                angle: angle,
                isActive: isActive || show,
                onClick: function() {
                    return setShow(!show);
                }
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("field__content", [
                    show && "is-active"
                ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default())),
                "aria-hidden": !show,
                children: (contentVisible || show) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().field__wrapper),
                    children: [
                        isSimple && isLaptop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().field__label),
                            children: props.value
                        }),
                        children,
                        footer && !isSimple && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().field__footer),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    onClick: handleClear,
                                    disabled: disableClear,
                                    arrow: false,
                                    variant: [
                                        "xs",
                                        "secondary",
                                        "-offset-left"
                                    ],
                                    type: "button",
                                    children: clearTranslation
                                }),
                                onApply && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    variant: [
                                        "xs"
                                    ],
                                    arrow: false,
                                    onClick: handleApply,
                                    type: "submit",
                                    disabled: disableApply,
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().footer),
                                    children: applyTranslation
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DropdownField);


/***/ }),

/***/ 84052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "areReactDatesLoaded": function() { return /* binding */ areReactDatesLoaded; },
  "default": function() { return /* binding */ form_Calendar; },
  "preloadReactDates": function() { return /* binding */ preloadReactDates; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dates/initialize.js
var initialize = __webpack_require__(6063);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(5950);
// EXTERNAL MODULE: ./components/elements/ErrorBoundary/styles.module.scss
var styles_module = __webpack_require__(14767);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/elements/ErrorBoundary/index.js









var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, _Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleReset", function() {
            _this.setState({
                hasError: false,
                error: null
            });
        });
        _this.state = {
            hasError: false,
            error: null
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("ErrorBoundary caught an error:", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).errorBoundary,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).errorBoundary__content,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (styles_module_default()).errorBoundary__message,
                                    children: this.props.fallbackMessage || "Something went wrong. Please try again."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (styles_module_default()).errorBoundary__button,
                                    onClick: this.handleReset,
                                    type: "button",
                                    children: "Try Again"
                                })
                            ]
                        })
                    });
                }
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    hasError: true,
                    error: error
                };
            }
        }
    ]);
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var elements_ErrorBoundary = (ErrorBoundary);

// EXTERNAL MODULE: ./node_modules/react-dates/lib/css/_datepicker.css
var _datepicker = __webpack_require__(19498);
;// CONCATENATED MODULE: ./public/icons/icon-calendar-next.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconCalendarNext = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 8,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "m1 13 5.793-6.069L1.115 1",
  stroke: "#fff",
  strokeWidth: 1.2,
  strokeLinecap: "square"
})));

/* harmony default export */ var icon_calendar_next = (SvgIconCalendarNext);
;// CONCATENATED MODULE: ./public/icons/icon-calendar-previous.svg
var icon_calendar_previous_path;

function icon_calendar_previous_extends() { icon_calendar_previous_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_calendar_previous_extends.apply(this, arguments); }



const SvgIconCalendarPrevious = props => /*#__PURE__*/react.createElement("svg", icon_calendar_previous_extends({
  width: 8,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_calendar_previous_path || (icon_calendar_previous_path = /*#__PURE__*/react.createElement("path", {
  d: "M6.793 13 1 6.931 6.678 1",
  stroke: "#fff",
  strokeWidth: 1.2,
  strokeLinecap: "square"
})));

/* harmony default export */ var icon_calendar_previous = (SvgIconCalendarPrevious);
// EXTERNAL MODULE: ./components/elements/form/Calendar/styles.module.scss
var Calendar_styles_module = __webpack_require__(33842);
var Calendar_styles_module_default = /*#__PURE__*/__webpack_require__.n(Calendar_styles_module);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./components/elements/DropdownField/index.js
var DropdownField = __webpack_require__(16971);
// EXTERNAL MODULE: ./components/elements/form/Radio/index.js
var Radio = __webpack_require__(87048);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./public/icons/icon-calendar.svg
var icon_calendar = __webpack_require__(48976);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./providers/SearchContext.js
var SearchContext = __webpack_require__(65079);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/elements/form/Calendar/index.js












var DayPickerRangeController = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4634), __webpack_require__.e(5900)]).then(__webpack_require__.bind(__webpack_require__, 25900));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25900)
            ];
        }
    },
    ssr: false
});
var DayPickerSingleDateController = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4634), __webpack_require__.e(9368)]).then(__webpack_require__.bind(__webpack_require__, 99368));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99368)
            ];
        }
    },
    ssr: false
});
// Preload function to initialize react-dates components on hover
// This triggers the dynamic imports so they're ready when the calendar opens
var preloadPromise = null;
var componentsLoaded = false;
var preloadReactDates = function() {
    // Only preload once to avoid multiple requests
    if (preloadPromise) return preloadPromise;
    preloadPromise = Promise.all([
        Promise.all(/* import() */[__webpack_require__.e(4634), __webpack_require__.e(5900)]).then(__webpack_require__.bind(__webpack_require__, 25900)),
        Promise.all(/* import() */[__webpack_require__.e(4634), __webpack_require__.e(9368)]).then(__webpack_require__.bind(__webpack_require__, 99368))
    ]).then(function() {
        componentsLoaded = true;
    }).catch(function() {
        // Reset on error so we can retry
        preloadPromise = null;
        componentsLoaded = false;
    });
    return preloadPromise;
};
// Check if components are already loaded
var areReactDatesLoaded = function() {
    return componentsLoaded;
};
















var Calendar = function(_param) {
    var setStartDate = _param.setStartDate, setEndDate = _param.setEndDate, setOffsetDays = _param.setOffsetDays, numberOfMonths = _param.numberOfMonths, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, _clearable = _param.clearable, clearable = _clearable === void 0 ? false : _clearable, _yearJump = _param.yearJump, yearJump = _yearJump === void 0 ? false : _yearJump, setDate = _param.setDate, _withOffset = _param.withOffset, withOffset = _withOffset === void 0 ? false : _withOffset, _blockedDates = _param.blockedDates, blockedDates = _blockedDates === void 0 ? false : _blockedDates, type = _param.type, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, // eslint-disable-next-line no-unused-vars
    date = _param.date, translations = _param.translations, minimumNights = _param.minimumNights, className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "setStartDate",
        "setEndDate",
        "setOffsetDays",
        "numberOfMonths",
        "variant",
        "clearable",
        "yearJump",
        "setDate",
        "withOffset",
        "blockedDates",
        "type",
        "disabled",
        "date",
        "translations",
        "minimumNights",
        "className",
        "children"
    ]);
    var isSmallMobile = (0,ResponsiveContext/* useResponsive */.F)().isSmallMobile;
    var router = (0,next_router.useRouter)();
    var ref = (0,SearchContext/* useSearchContext */.AB)(), offsetable = ref.offsetable, search = ref.search;
    // Debug mode detection - controlled by URL parameter ?debug=calendar
    // Memoized to avoid repeated URLSearchParams parsing on every render
    var isDebugMode = (0,react.useMemo)(function() {
        return  true && new URLSearchParams(window.location.search).get("debug") === "calendar";
    }, []);
    var previousLocaleRef = (0,react.useRef)(null);
    var localeEnforcedRef = (0,react.useRef)(false);
    // Get the correct locale for the calendar - use router.locale
    var calendarLocale = router.locale || "en";
    // Ensure react-dates uses the correct locale for the current page
    // Use useLayoutEffect to set locale synchronously before render
    (0,react.useLayoutEffect)(function() {
        if (!previousLocaleRef.current) {
            previousLocaleRef.current = moment_default().locale();
        }
        // Set locale based on current page language
        moment_default().locale(calendarLocale);
        localeEnforcedRef.current = true;
        return function() {
            localeEnforcedRef.current = false;
            if (previousLocaleRef.current) {
                moment_default().locale(previousLocaleRef.current);
            }
        };
    }, [
        calendarLocale
    ]);
    // Keep locale synced with router.locale even if something else changes it
    (0,react.useEffect)(function() {
        if (localeEnforcedRef.current) {
            if (moment_default().locale() !== calendarLocale) {
                moment_default().locale(calendarLocale);
            }
        }
    }, [
        calendarLocale
    ]);
    var ref1 = (0,react.useState)("startDate"), focusedInput = ref1[0], setFocusedInput = ref1[1];
    var ref2 = (0,react.useState)(moment_default()().utc().startOf("day")), initialMonth = ref2[0], setInitialMonth = ref2[1];
    var ref3 = (0,react.useState)(moment_default()().utc().startOf("day")), singleCalendarMonth = ref3[0], setSingleCalendarMonth = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(false), checked = ref5[0], setChecked = ref5[1];
    var ref6 = (0,react.useState)(offsetable), offset = ref6[0], setOffset = ref6[1];
    var calendarWrapperRef = (0,react.useRef)(null);
    var componentsReadyRef = (0,react.useRef)(componentsLoaded);
    // Check if components are already loaded on mount and update ref
    (0,react.useEffect)(function() {
        // If components are already marked as loaded, use that
        if (componentsLoaded) {
            componentsReadyRef.current = true;
            return;
        }
        // Check if preload promise exists and wait for it
        if (preloadPromise) {
            preloadPromise.then(function() {
                componentsReadyRef.current = true;
            }).catch(function() {
                componentsReadyRef.current = false;
            });
        } else {
            // Try to preload now and mark as ready when done
            var checkReady = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                _ctx.next = 3;
                                return Promise.all([
                                    Promise.all(/* import() */[__webpack_require__.e(4634), __webpack_require__.e(5900)]).then(__webpack_require__.bind(__webpack_require__, 25900)),
                                    Promise.all(/* import() */[__webpack_require__.e(4634), __webpack_require__.e(9368)]).then(__webpack_require__.bind(__webpack_require__, 99368))
                                ]);
                            case 3:
                                componentsReadyRef.current = true;
                                _ctx.next = 9;
                                break;
                            case 6:
                                _ctx.prev = 6;
                                _ctx.t0 = _ctx["catch"](0);
                                componentsReadyRef.current = false;
                            case 9:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            6
                        ]
                    ]);
                }));
                return function checkReady() {
                    return _ref.apply(this, arguments);
                };
            }();
            checkReady();
        }
    }, []);
    // Debug log when blocked dates are loaded
    (0,react.useEffect)(function() {
        if (isDebugMode && blockedDates && blockedDates.length > 0) {
            console.log("[Calendar Debug] Blocked dates loaded:", {
                count: blockedDates.length,
                dates: blockedDates.map(function(d) {
                    return d.format("YYYY-MM-DD");
                }).sort()
            });
        }
    }, [
        blockedDates,
        isDebugMode
    ]);
    var returnNearestDayUp = (0,react.useCallback)(function() {
        var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var nearestDate;
        blockedDates && blockedDates.map(function(date) {
            var diff = date.diff(search.startDate, "days");
            if (diff > offset && !date.isSame(search.startDate, "day")) {
                if (nearestDate) {
                    if (date.diff(nearestDate, "days") < 0) {
                        nearestDate = date;
                    }
                } else {
                    nearestDate = date;
                }
            }
        });
        return nearestDate;
    }, [
        blockedDates,
        search.startDate
    ]);
    var returnNearestDayDown = (0,react.useCallback)(function() {
        var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var nearestDate;
        blockedDates && blockedDates.map(function(date) {
            var diff = date.diff(search.endDate, "days");
            if (diff < offset) {
                if (nearestDate) {
                    if (date.diff(nearestDate, "days") > 0) {
                        nearestDate = date;
                    }
                } else {
                    nearestDate = date;
                }
            }
        });
        return nearestDate;
    }, [
        blockedDates,
        search.endDate
    ]);
    (0,react.useEffect)(function() {
        // Skip loading state if components are already ready
        if (componentsReadyRef.current) {
            return;
        }
        setLoading(true);
        var timer = setTimeout(function() {
            return setLoading(false);
        }, 300);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        blockedDates
    ]);
    var defaultProps = (0,react.useMemo)(function() {
        return {
            navPrev: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar_previous, {}),
            navNext: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar_next, {}),
            daySize: isSmallMobile ? 30 : 35,
            numberOfMonths: numberOfMonths ? numberOfMonths : isSmallMobile ? 1 : 2
        };
    }, [
        isSmallMobile,
        numberOfMonths
    ]);
    // Removed unused transitionContainerStyle - styles are applied directly via useEffect
    var returnYears = (0,react.useCallback)(function() {
        var years = [];
        for(var i = Number(moment_default()().utc().format("YYYY")); i <= moment_default()().utc().add(2, "years").format("YYYY"); i++){
            years.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                variant: [
                    "underline"
                ],
                onChange: function(e) {
                    var currentMonth = initialMonth.clone();
                    var monthDiff = currentMonth.format("M") - 1;
                    setChecked(Number(e.target.value));
                    setDate(Number(e.target.value));
                    setInitialMonth(moment_default()(e.target.value).utc().add(monthDiff, "months"));
                    // Skip loading if components are already ready
                    if (!componentsReadyRef.current) {
                        setLoading(true);
                        var timer = setTimeout(function() {
                            return setLoading(false);
                        }, 300);
                        return function() {
                            return clearTimeout(timer);
                        };
                    }
                },
                name: "years",
                label: i,
                checked: checked === i,
                value: i,
                children: i
            }, "Radio-".concat(i)));
        }
        return years;
    }, [
        checked,
        initialMonth,
        setDate
    ]);
    (0,react.useEffect)(function() {
        if (props.startDate === null) {
            setFocusedInput("startDate");
        }
        if (props.startDate && props.endDate === null) {
            setFocusedInput("endDate");
        }
        if (props.startDate && props.endDate) {
            setFocusedInput("startDate");
        }
    }, [
        props.startDate,
        props.endDate
    ]);
    (0,react.useEffect)(function() {
        if (!calendarWrapperRef.current) return;
        var container = calendarWrapperRef.current.querySelector('[class*="DayPicker_transitionContainer"]');
        if (container) {
            container.style.height = "auto";
            container.style.minHeight = "".concat(isSmallMobile ? 260 : 320, "px");
        }
        // Function to override inline styles on week headers
        var overrideWeekHeaderStyles = function() {
            var weekHeaders = calendarWrapperRef.current.querySelectorAll('[class*="DayPicker_weekHeader"]');
            weekHeaders.forEach(function(header) {
                if (header.style.padding) {
                    header.style.padding = "0 9px";
                }
                // Override left position for second month (December) to align properly
                // First month is typically around 0-20px, second month is around 272px
                var leftValue = parseInt(header.style.left);
                if (leftValue > 250) {
                    header.style.left = "257px";
                }
            });
        };
        // Apply immediately
        overrideWeekHeaderStyles();
        // Use MutationObserver to catch when react-dates applies inline styles
        var observer = new MutationObserver(function() {
            overrideWeekHeaderStyles();
        });
        if (container) {
            observer.observe(container, {
                attributes: true,
                subtree: true,
                attributeFilter: [
                    "style"
                ]
            });
        }
        return function() {
            observer.disconnect();
        };
    }, [
        isSmallMobile,
        numberOfMonths,
        loading,
        focusedInput,
        props.startDate,
        props.endDate
    ]);
    var handleDatesChange = (0,react.useCallback)(function(startDate, endDate) {
        // Debug log when user clicks dates
        if (isDebugMode) {
            var ref, ref1;
            console.log("[Calendar Debug] Date clicked:", {
                newStart: startDate === null || startDate === void 0 ? void 0 : startDate.format("YYYY-MM-DD"),
                newEnd: endDate === null || endDate === void 0 ? void 0 : endDate.format("YYYY-MM-DD"),
                currentStart: (ref = props.startDate) === null || ref === void 0 ? void 0 : ref.format("YYYY-MM-DD"),
                currentEnd: (ref1 = props.endDate) === null || ref1 === void 0 ? void 0 : ref1.format("YYYY-MM-DD"),
                focusedInput: focusedInput
            });
        }
        // Ensure dates are set to start of day
        var normalizedStartDate = startDate ? moment_default()(startDate).utc().startOf("day") : null;
        var normalizedEndDate = endDate ? moment_default()(endDate).utc().startOf("day") : null;
        // Functionality that focuses start date / end date
        // It will always have first click start date, second click end date
        if (props.startDate === null && props.endDate === null) {
            setStartDate(normalizedStartDate);
            setTimeout(function() {
                return setFocusedInput("endDate");
            }, 10);
        }
        if (props.startDate === null && props.endDate) {
            setStartDate(normalizedStartDate);
            setTimeout(function() {
                return setFocusedInput("endDate");
            }, 10);
        }
        if (props.startDate && props.endDate === null) {
            setEndDate(normalizedEndDate);
            setTimeout(function() {
                return setFocusedInput("startDate");
            }, 10);
        }
        if (props.startDate && props.endDate) {
            setEndDate(null);
            setStartDate(normalizedStartDate);
            setTimeout(function() {
                return setFocusedInput("endDate");
            }, 10);
        }
        if (normalizedStartDate && (normalizedStartDate === null || normalizedStartDate === void 0 ? void 0 : normalizedStartDate.isBefore(props.startDate, "day")) || (normalizedStartDate === null || normalizedStartDate === void 0 ? void 0 : normalizedStartDate.isAfter(props.endDate, "day"))) {
            setEndDate(null);
            setStartDate(normalizedStartDate);
            setTimeout(function() {
                return setFocusedInput("endDate");
            }, 10);
        }
    }, [
        props.startDate,
        props.endDate,
        setStartDate,
        setEndDate,
        focusedInput,
        isDebugMode
    ]);
    var onFocusChange = (0,react.useCallback)(function(focusedInput) {
        setFocusedInput(focusedInput);
    }, []);
    // Track if we've logged the debug summary
    var debugLoggedRef = (0,react.useRef)(false);
    var rangeControllerIsOutside = (0,react.useCallback)(function(day) {
        var dayStr = day.format("YYYY-MM-DD");
        var sampleDates = [
            "2025-12-05",
            "2025-12-11",
            "2025-12-15",
            "2026-01-25"
        ];
        var isSampleDate = sampleDates.includes(dayStr);
        // Log summary once
        if (isDebugMode && !debugLoggedRef.current) {
            var ref, ref1;
            debugLoggedRef.current = true;
            console.log("[Calendar Debug] isOutsideRange check:", {
                hasBlockedDates: !!blockedDates,
                blockedDatesLength: blockedDates === null || blockedDates === void 0 ? void 0 : blockedDates.length,
                isEmptyResult: (0,isEmpty/* default */.Z)(blockedDates),
                blockedDatesType: typeof blockedDates === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(blockedDates),
                isArray: Array.isArray(blockedDates),
                firstBlockedDate: blockedDates === null || blockedDates === void 0 ? void 0 : (ref = blockedDates[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.format) === null || ref1 === void 0 ? void 0 : ref1.call(ref, "YYYY-MM-DD"),
                todayUTC: moment_default()().utc().format("YYYY-MM-DD HH:mm:ss"),
                todayLocal: moment_default()().format("YYYY-MM-DD HH:mm:ss")
            });
        }
        if (blockedDates && !(0,isEmpty/* default */.Z)(blockedDates)) {
            var BlockedDate = blockedDates.find(function(item) {
                return item.format("YYYY-MM-DD") === day.format("YYYY-MM-DD");
            });
            // Log sample dates to see why they're blocked/available
            if (isDebugMode && isSampleDate) {
                var result = "AVAILABLE";
                if (BlockedDate) {
                    result = "BLOCKED (in list)";
                } else if (day.isBefore(moment_default()().utc(), "day")) {
                    result = "BLOCKED (past)";
                }
                console.log("[Calendar Debug] Sample date ".concat(dayStr, ":"), {
                    isInBlockedList: !!BlockedDate,
                    isBefore: day.isBefore(moment_default()().utc(), "day"),
                    result: result
                });
            }
            if (props.startDate && focusedInput === "endDate") {
                var NextDay = day.clone().subtract(1, "day");
                var EndBlocked = blockedDates && blockedDates.find(function(item) {
                    return item.format("YYYY-MM-DD") === NextDay.format("YYYY-MM-DD");
                });
                var nearestDate = returnNearestDayUp(-1);
                var booked = EndBlocked === null || EndBlocked === void 0 ? void 0 : EndBlocked.clone();
                if (nearestDate) {
                    var isBlocked = (day === null || day === void 0 ? void 0 : day.isAfter(nearestDate, "day")) + (day === null || day === void 0 ? void 0 : day.isSame(booked === null || booked === void 0 ? void 0 : booked.clone().add(1, "day"), "day")) + (day === null || day === void 0 ? void 0 : day.isBefore(moment_default()().utc(), "day"));
                    return isBlocked;
                }
            }
            if (props.endDate && props.startDate === null && focusedInput === "startDate") {
                var nearestDate1 = returnNearestDayDown();
                if (nearestDate1) {
                    var isBlocked1 = day.isBefore(nearestDate1, "day") + day.isSame(BlockedDate, "day");
                    return isBlocked1;
                }
            }
            if (day.isSame(moment_default()().utc())) {
                return 0;
            }
            var isBlocked2 = day.isSame(BlockedDate, "day") + day.isBefore(moment_default()().utc(), "day");
            return isBlocked2;
        }
        var isBlocked3 = day.isBefore(moment_default()().utc(), "day");
        return isBlocked3;
    }, [
        blockedDates,
        props.startDate,
        props.endDate,
        focusedInput,
        returnNearestDayUp,
        returnNearestDayDown,
        isDebugMode
    ]);
    var onPrevMonthClick = (0,react.useCallback)(function(month) {
        if (setEndDate) {
            setInitialMonth(month);
            setChecked(Number(month.format("YYYY")));
            setDate(Number(month.format("YYYY")));
            // Skip loading if components are already ready
            if (!componentsReadyRef.current) {
                setLoading(true);
                var timer = setTimeout(function() {
                    return setLoading(false);
                }, 300);
                return function() {
                    return clearTimeout(timer);
                };
            }
        }
    }, [
        setEndDate,
        setDate
    ]);
    var onNextMonthClick = (0,react.useCallback)(function(month) {
        if (setEndDate) {
            setInitialMonth(month);
            setChecked(Number(month.format("YYYY")));
            setDate(Number(month.format("YYYY")));
            // Skip loading if components are already ready
            if (!componentsReadyRef.current) {
                setLoading(true);
                var timer = setTimeout(function() {
                    return setLoading(false);
                }, 300);
                return function() {
                    return clearTimeout(timer);
                };
            }
        }
    }, [
        setEndDate,
        setDate
    ]);
    (0,react.useEffect)(function() {
        if (type === "startDate" || type === "endDate") {
            if (search.startDate) {
                setSingleCalendarMonth(moment_default()(search.startDate).utc().startOf("day"));
                // Skip loading if components are already ready
                if (!componentsReadyRef.current) {
                    setLoading(true);
                    var timer = setTimeout(function() {
                        return setLoading(false);
                    }, 300);
                    return function() {
                        return clearTimeout(timer);
                    };
                }
            }
            if (search.endDate) {
                setSingleCalendarMonth(moment_default()(search.endDate).utc().startOf("day"));
                // Skip loading if components are already ready
                if (!componentsReadyRef.current) {
                    setLoading(true);
                    var timer1 = setTimeout(function() {
                        return setLoading(false);
                    }, 300);
                    return function() {
                        return clearTimeout(timer1);
                    };
                }
            }
        }
    }, [
        search.startDate,
        search.endDate,
        type
    ]);
    var dayPickerOutsideRange = (0,react.useCallback)(function(day) {
        var defaultBlocked = day.isBefore(moment_default()().utc(), "day");
        if (blockedDates && !(0,isEmpty/* default */.Z)(blockedDates)) {
            if (type === "startDate") {
                var BlockedDate = blockedDates && blockedDates.find(function(item) {
                    return item.format("YYYY-MM-DD") === day.format("YYYY-MM-DD");
                });
                if (search.endDate) {
                    // checks so that you can't select a date that overlaps range of blocked dates
                    var isBlocked = defaultBlocked + (day === null || day === void 0 ? void 0 : day.isSame(BlockedDate, "day")) + (day === null || day === void 0 ? void 0 : day.isSame(search.endDate, "day")) + (day === null || day === void 0 ? void 0 : day.isAfter(moment_default()().utc().add(3, "years")));
                    return isBlocked;
                }
                if (day.isSame(moment_default()().utc(), "day") && !BlockedDate) {
                    return 0;
                }
                var isBlocked1 = defaultBlocked + (day === null || day === void 0 ? void 0 : day.isSame(BlockedDate, "day")) + (day === null || day === void 0 ? void 0 : day.isAfter(moment_default()().utc().add(3, "years")));
                return isBlocked1;
            }
            if (type === "endDate") {
                var NextDay = day.clone().subtract(1, "day");
                var BlockedDate1 = blockedDates && blockedDates.find(function(item) {
                    return item.format("YYYY-MM-DD") === NextDay.format("YYYY-MM-DD");
                });
                var booked = BlockedDate1 === null || BlockedDate1 === void 0 ? void 0 : BlockedDate1.clone();
                if (search.startDate) {
                    // checks so that you can't select a date that overlaps range of blocked dates
                    var nearestDate = returnNearestDayUp();
                    if (nearestDate) {
                        var isBlocked2 = defaultBlocked + (day === null || day === void 0 ? void 0 : day.isSame(booked === null || booked === void 0 ? void 0 : booked.clone().add(1, "day"), "day")) + (day === null || day === void 0 ? void 0 : day.isSame(search.startDate, "day")) + (day === null || day === void 0 ? void 0 : day.isAfter(moment_default()().utc().add(3, "years")));
                        return isBlocked2;
                    }
                    var isBlocked3 = defaultBlocked + BlockedDate1 + (day === null || day === void 0 ? void 0 : day.isSame(search.startDate, "day")) + (day === null || day === void 0 ? void 0 : day.isAfter(moment_default()().utc().add(3, "years")));
                    return isBlocked3;
                }
                var isBlocked4 = defaultBlocked + (day === null || day === void 0 ? void 0 : day.isSame(booked === null || booked === void 0 ? void 0 : booked.clone().add(1, "day"), "day")) + (day === null || day === void 0 ? void 0 : day.isAfter(moment_default()().utc().add(3, "years")));
                return isBlocked4;
            }
        }
        return defaultBlocked;
    }, [
        blockedDates,
        type,
        search.endDate,
        search.startDate,
        returnNearestDayUp
    ]);
    // Memoize the calendar key to only update when the month changes, not when blocked dates change
    // This prevents unnecessary re-mounts of the DayPickerRangeController
    var calendarKey = (0,react.useMemo)(function() {
        return initialMonth.format("YYYY-MM");
    }, [
        initialMonth
    ]);
    // Ensure locale is correct right before rendering react-dates components
    // This runs synchronously during render to ensure react-dates uses the page locale
    if (true) {
        moment_default().locale(calendarLocale);
    }
    var minimumNightsValue = (0,react.useMemo)(function() {
        return blockedDates && (returnNearestDayUp() === undefined || props.startDate && returnNearestDayUp() && returnNearestDayUp().diff(props.startDate, "days") > minimumNights) && minimumNights || 0;
    }, [
        blockedDates,
        returnNearestDayUp,
        props.startDate,
        minimumNights
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_ErrorBoundary, {
        fallbackMessage: "Unable to load calendar. Please refresh.",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()(className, (0,withModifiers/* withModifiers */.i)("calendar", (0,_to_consumable_array/* default */.Z)(variant).concat([
                disabled && "disabled"
            ]), (Calendar_styles_module_default()))),
            children: setEndDate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Calendar_styles_module_default()).calendar__wrapper,
                        ref: calendarWrapperRef,
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Calendar_styles_module_default()).calendar__skeleton,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Calendar_styles_module_default()).calendar__skeletonNav,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Calendar_styles_module_default()).calendar__skeletonMonth
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Calendar_styles_module_default()).calendar__skeletonGrid,
                                    children: Array.from({
                                        length: 42
                                    }).map(function(_, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Calendar_styles_module_default()).calendar__skeletonDay
                                        }, "skeleton-".concat(index));
                                    })
                                })
                            ]
                        }) : yearJump ? /*#__PURE__*/ (0,react.createElement)(DayPickerRangeController, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultProps), {
                            disabled: disabled,
                            onDatesChange: function(param) {
                                var startDate = param.startDate, endDate = param.endDate;
                                handleDatesChange(startDate, endDate);
                            },
                            key: calendarKey,
                            isOutsideRange: function(day) {
                                return rangeControllerIsOutside(day);
                            },
                            focusedInput: focusedInput,
                            onFocusChange: onFocusChange,
                            minDate: moment_default()().utc(),
                            onPrevMonthClick: function(month) {
                                return onPrevMonthClick(month);
                            },
                            onNextMonthClick: function(month) {
                                return onNextMonthClick(month);
                            },
                            initialVisibleMonth: function() {
                                return initialMonth;
                            },
                            maxDate: moment_default()().utc().add(3, "years"),
                            minimumNights: minimumNightsValue
                        }), props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,react.createElement)(DayPickerRangeController, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultProps), {
                                disabled: disabled,
                                key: calendarKey,
                                onDatesChange: function(param) {
                                    var startDate = param.startDate, endDate = param.endDate;
                                    handleDatesChange(startDate, endDate);
                                },
                                maxDate: moment_default()().utc().add(3, "years"),
                                isOutsideRange: function(day) {
                                    return rangeControllerIsOutside(day);
                                },
                                focusedInput: focusedInput,
                                onFocusChange: onFocusChange,
                                minDate: moment_default()().utc()
                            }), props))
                        })
                    }),
                    withOffset && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Calendar_styles_module_default()).calendar__offsets,
                        children: Array.from({
                            length: 4
                        }).map(function(currentElement, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                value: index,
                                label: index === 0 ? translations === null || translations === void 0 ? void 0 : translations.exactDates[router.locale] : "\xb1 ".concat(index, " ").concat(!isSmallMobile ? translations === null || translations === void 0 ? void 0 : translations.days[router.locale] : ""),
                                onChange: function(e) {
                                    setOffset(Number(e.target.value));
                                    setOffsetDays(Number(e.target.value));
                                },
                                name: "offset",
                                checked: index === offset,
                                variant: [
                                    "inline",
                                    "boxed"
                                ]
                            }, "Radio-".concat(currentElement, "-").concat(index));
                        })
                    }),
                    (clearable || yearJump) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((Calendar_styles_module_default()).calendar__footer, "calendar-footer"),
                        children: [
                            children,
                            clearable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                type: "button",
                                onClick: function() {
                                    setStartDate(null);
                                    setEndDate(null);
                                    setFocusedInput("startDate");
                                },
                                disabled: props.startDate === null && props.endDate === null,
                                variant: [
                                    "label",
                                    "gray"
                                ],
                                arrow: false,
                                children: isSmallMobile ? translations === null || translations === void 0 ? void 0 : translations.clear[router.locale] : translations === null || translations === void 0 ? void 0 : translations.clearDates[router.locale]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Calendar_styles_module_default()).calendar__select,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Calendar_styles_module_default()).calendar__label,
                                        children: translations.skip[router.locale]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownField/* default */.Z, {
                                        variant: [
                                            "top",
                                            "dropdown",
                                            "accent",
                                            "p-xs"
                                        ],
                                        footer: false,
                                        name: "yearChange",
                                        width: 9.4,
                                        disabled: disabled,
                                        prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar/* default */.Z, {}),
                                        value: initialMonth.format("YYYY"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: returnYears()
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !clearable && !yearJump && children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((Calendar_styles_module_default()).calendar__footer, "calendar-footer"),
                        children: children
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,withModifiers/* withModifiers */.i)("calendar__single", [
                    disabled && "disabled"
                ], (Calendar_styles_module_default())),
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Calendar_styles_module_default()).calendar__skeleton,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Calendar_styles_module_default()).calendar__skeletonNav,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Calendar_styles_module_default()).calendar__skeletonMonth
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Calendar_styles_module_default()).calendar__skeletonGrid,
                            children: Array.from({
                                length: 35
                            }).map(function(_, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Calendar_styles_module_default()).calendar__skeletonDay
                                }, "skeleton-single-".concat(index));
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DayPickerSingleDateController, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultProps), {
                        transitionDuration: 0,
                        onDateChange: function(date) {
                            setStartDate(date);
                        },
                        initialVisibleMonth: function() {
                            return singleCalendarMonth;
                        },
                        date: props.startDate,
                        focused: true,
                        isOutsideRange: function(day) {
                            return dayPickerOutsideRange(day);
                        }
                    }))
                })
            })
        })
    });
};
var withCalendar = function(Component) {
    return function Wrapper(props) {
        var ref = (0,react.useState)(0), date = ref[0], setDate = ref[1];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({
            date: date,
            setDate: setDate
        }, props));
    };
};
/* harmony default export */ var form_Calendar = (withCalendar(Calendar));


/***/ }),

/***/ 83378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"calendarSkeleton":"styles_calendarSkeleton__wB5ic","dates":"styles_dates__U6svE","dates--mobile":"styles_dates--mobile__NpJFJ","dates--filter":"styles_dates--filter__WGQgw","dates--property":"styles_dates--property__HGyKH","dates__input":"styles_dates__input__njqC_","dates__input--active":"styles_dates__input--active__s_INR","dates__icon":"styles_dates__icon__BfKfz","dates__value":"styles_dates__value__y_VxS","dates__flexibility_hint":"styles_dates__flexibility_hint__XmyLa","dates__wrapper":"styles_dates__wrapper___h_n4","isActive":"styles_isActive__vEaqM","custom":"styles_custom__AYSYy","dates__wrapper--property":"styles_dates__wrapper--property__DDUUn","dates__wrapper--filter":"styles_dates__wrapper--filter__4sfr3","dates__footer":"styles_dates__footer__tG5rs","dates__footer--no-flex":"styles_dates__footer--no-flex__AobBQ","dates__flexibility":"styles_dates__flexibility__X0kry","dates__flexButton":"styles_dates__flexButton__5ANPc","dates__flexButton--active":"styles_dates__flexButton--active__qU_lF","dates__clearButton":"styles_dates__clearButton__M7sww"};

/***/ }),

/***/ 49727:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"field":"styles_field__h8_cg","field__label":"styles_field__label__ezuBG","field__wrapper":"styles_field__wrapper__hfZnh","field__content":"styles_field__content__rCr6i","field__content--is-active":"styles_field__content--is-active__6eGg0","field__footer":"styles_field__footer__UhQVV","field--right":"styles_field--right__7SxmX","field--top":"styles_field--top__WGOsK","field--content-simple":"styles_field--content-simple__Lrcd4","field--content-xs":"styles_field--content-xs__K86T2","field--footer-close":"styles_field--footer-close__BwEfB"};

/***/ }),

/***/ 14767:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"errorBoundary":"styles_errorBoundary__CzYne","errorBoundary__content":"styles_errorBoundary__content__h56JI","errorBoundary__message":"styles_errorBoundary__message__qWRiR","errorBoundary__button":"styles_errorBoundary__button__1cetg"};

/***/ }),

/***/ 33842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"calendar":"styles_calendar__z0bFn","calendar__footer":"styles_calendar__footer__WWWcx","calendar__select":"styles_calendar__select__bLNvB","calendar__label":"styles_calendar__label__VOuYY","calendar__offsets":"styles_calendar__offsets__uRlsb","calendar__wrapper":"styles_calendar__wrapper__U347A","calendar--disabled":"styles_calendar--disabled__sooj4","calendar__skeleton":"styles_calendar__skeleton__pOIZW","calendar__skeletonNav":"styles_calendar__skeletonNav__SrwO9","calendar__skeletonMonth":"styles_calendar__skeletonMonth__AXngm","skeleton-pulse":"styles_skeleton-pulse__tQgFH","calendar__skeletonGrid":"styles_calendar__skeletonGrid__cwoTX","calendar__skeletonDay":"styles_calendar__skeletonDay__rB_im","calendar--large":"styles_calendar--large__inLSv","calendar__single":"styles_calendar__single__Vx64K","calendar__single--disabled":"styles_calendar__single--disabled__Aqqvd","calendar--dark":"styles_calendar--dark__YXKsx"};

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);